import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SenderInfoResetModule } from '@galaxy/email-ui/sender-info-reset';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { EmailModule } from '@vendasta/email';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxySnackbarModule, SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { CopycatModule } from '../common/copycat/copycate.module';
import { PageComponent } from '../common/page.component';
import { WEBLATE_COMPONENT_NAME } from '../constants';
import { CampaignSettingsComponent } from './campaign-settings.component';
import { CampaignSettingsService } from './campaign-settings.service';
import { DkimValidationComponent } from './dkim-validation/dkim-validation.component';
import { DmarcValidationComponent } from './dmarc-validation/dmarc-validation.component';
import { PendingDomainModule } from './pending-domain/pending-domain.module';
import { PostmasterToolsComponent } from './postmaster-tools/postmaster-tools.component';
import { SendAsComponent } from './send-as/send-as.component';
import { UpdateSenderDialogComponent } from './send-as/update-sender-dialog.component';
import { UseSafeDefaultsDialogComponent } from './send-as/use-safe-defaults-dialog/use-safe-defaults-dialog.component';
import { DomainRecordsModule } from './shared/domain-records.module';
import { SPFService } from './shared/spf.service';
import { SpfValidationComponent } from './spf-validation/spf-validation.component';
import { GalaxyPageModule } from '@vendasta/galaxy/page';

@NgModule({
  declarations: [
    SendAsComponent,
    CampaignSettingsComponent,
    PostmasterToolsComponent,
    DmarcValidationComponent,
    DkimValidationComponent,
    UpdateSenderDialogComponent,
    SpfValidationComponent,
    UseSafeDefaultsDialogComponent,
  ],
  imports: [
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatExpansionModule,
    MatDialogModule,
    CommonModule,
    ReactiveFormsModule,
    CopycatModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    GalaxyInputModule,
    GalaxyAlertModule,
    GalaxyEmptyStateModule,
    GalaxySnackbarModule,
    EmailModule,
    PendingDomainModule,
    DomainRecordsModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    SenderInfoResetModule,
    GalaxyTooltipModule,
    PageComponent,
    GalaxyPageModule,
  ],
  exports: [
    SendAsComponent,
    CampaignSettingsComponent,
    PostmasterToolsComponent,
    DmarcValidationComponent,
    DkimValidationComponent,
  ],
  providers: [CampaignSettingsService, SPFService, SnackbarService],
})
export class CampaignSettingsModule {}
